import _ from 'lodash'
import TransitionAnimation from '../transition/transition-animation'
import CarouselIndicator from './CarouselIndicator'
import CarouselControl from './CarouselControl'
import $ from 'jquery'

export default {
  name: 'KCarousel',
  provide() {
    return {
      carousel: this,
    }
  },
  mixins: [],
  props: {
    initialIndex: {
      type: Number,
      default: 0,
    },
    height: {
      type: String,
      default: '',
    },
    // 自动高度，为 true 时，使用当前激活的 item 的高度
    autoHeight: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 3000,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    pauseOnHover: {
      type: Boolean,
      default: true,
    },
    transition: {
      validator: value => _.hasIn(TransitionAnimation, value),
      // `moveToLeft`
      default() {
        return 'moveToLeft'
      },
    },
    animatingOnInit: {
      type: Boolean,
      default: false,
    },
    indicator: {
      type: [Boolean, String], // false: no show indicator, 'line': show as line
      default: false,
    },
    indicatorPosition: {
      type: String,
      default: 'center', // center, left, right
    },
    indicatorOutside: {
      type: Boolean,
      default: false,
    },
    control: {
      type: [Boolean, String], // false: no show control, 'hover': show on hover
      default: false,
    },
  },
  data() {
    return {
      items: [],
      timer: null, // 定时器
      activeIndex: -1,
      prevIndex: null,
      hover: false,
      triggeredBy: null,
      innerHeight: null,
    }
  },
  computed: {},
  watch: {
    activeIndex(activeIndex, prevIndex) {
      this.trot(prevIndex)
      this.$emit('change', activeIndex, prevIndex)
    },
    autoplay(auto) {
      auto ? this.startTimer() : this.pauseTimer()
    },
    items() {
      if (this.items.length > 0) {
        this.setActiveItem(this.initialIndex)
      }
    },
    hover(value) {
      if (!this.pauseOnHover) {
        return
      }

      value ? this.pauseTimer() : this.startTimer()
    },
    height: {
      immediate: true,
      handler(value) {
        this.innerHeight = value
      },
    },
  },
  mounted() {
    this.updateItems()
    this.$nextTick(() => {
      this.startTimer()
    })
  },
  beforeDestroy() {
    this.pauseTimer()
  },
  methods: {
    trot(prevIndex) {
      this.prevIndex = prevIndex
    },
    pauseTimer() {
      clearInterval(this.timer)
    },
    startTimer() {
      if (this.interval <= 0 || !this.autoplay) {
        return
      }
      if (this.pauseOnHover && this.hover) {
        this.pauseTimer()
      } else {
        clearInterval(this.timer)
        this.timer = setInterval(this.next, this.interval)
      }
    },
    // play() {
    //   this.next()
    // },
    updateItems() {
      this.items = _.forEach(_.filter(this.$children, child => child.$options.name === 'KCarouselItem'), (item, index) => {
        item.index = index
      })
    },
    handleMouseEnter(e) {
      e && e.stopPropagation()

      this.hover = true
    },
    handleMouseLeave(e) {
      e && e.stopPropagation()
      if (e.toElement && e.toElement.classList.value.split(/\s+/).indexOf('km-carousel__item') !== -1) {
        this.hover = true
        return
      }
      this.hover = false
    },
    handleIndicatorClick({ index }) {
      this.pauseTimer()
      this.setActiveItem(index, 'indicator')

      this.$nextTick(() => {
        this.startTimer()
      })
    },
    /**
     * @public api
     * @param domElement
     * @return
     */
    setMaskRef(domElement) {
      $(domElement)
        .on('mouseenter', this.handleMouseEnter)
        .on('mouseleave', this.handleMouseLeave)
    },
    play() {
      this.startTimer()
    },
    pause() {
      this.pauseTimer()
    },
    setActiveItem(index, triggeredBy = null) { // indicator / control
      index = index < 0 ? index + this.items.length : index
      this.activeIndex = index % this.items.length
      this.triggeredBy = triggeredBy
    },
    prev(triggeredBy) {
      this.pauseTimer()
      this.setActiveItem(this.activeIndex - 1, triggeredBy)
      this.$nextTick(() => {
        this.startTimer()
      })
    },
    next() {
      this.pauseTimer()
      this.setActiveItem(this.activeIndex + 1)
      this.$nextTick(() => {
        this.startTimer()
      })
    },
  },
  render() {
    const style = {}
    if (this.innerHeight) {
      style.height = this.innerHeight
    }

    const css = {
      'km-carousel': true,
      'km-carousel--auto-height': this.autoHeight,
      'is-mb-20': this.indicatorOutside,
    }

    const attrs = {}

    const events = {
      mouseenter: this.handleMouseEnter,
      mouseleave: this.handleMouseLeave,
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    const innerStyle = {}
    if (this.autoHeight && this.innerHeight) {
      innerStyle.height = this.innerHeight
    }

    return (
      <div {...data}>
        <div
          class="km-carousel__inner"
          style={innerStyle}
        >
          {this.$slots.default}
        </div>
        {
          this.control
            ? <CarouselControl
              hover={this.control === 'hover'}
            />
            : null
        }
        {
          this.indicator
            ? <CarouselIndicator
              type={this.indicator === 'line' ? 'line' : ''}
              position={this.indicatorPosition}
              outside={this.indicatorOutside}
              onClick={this.handleIndicatorClick}
            >
              {this.$scopedSlots.indicator}
            </CarouselIndicator> : null
        }
      </div>
    )
  },
}
